import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-change-form-status',
  templateUrl: './change-form-status.component.html',
  styleUrls: ['./change-form-status.component.css']
})
export class ChangeFormStatusComponent implements OnInit {
  acc_id: any;
  status: any;
  setting_id: any;
  statusTo: string;
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService) { }

  ngOnInit() {
    this.acc_id = this.data.accountId;
    this.status = this.data.status;
    this.setting_id = this.data.id;
    if (this.status === 'Enable') {
      this.statusTo = 'Disable';
    } else {
      this.statusTo = 'Enable';
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.accountService.changeConsentFormSttatus(this.acc_id,this.setting_id,this.statusTo)
    .subscribe(
      data => {
        this.api_success = 'Status changed Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
}
